export default "__VITE_ASSET__B2znZXig__"